import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex h-screen w-screen items-center justify-center" };
const _hoisted_2 = { class: "flex flex-col" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-2 text-2xl font-medium" }, "写真管理アプリ version 0.1.0", -1);
const _hoisted_4 = { class: "text-xl" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ClipboardDocumentCheckIcon = _resolveComponent("ClipboardDocumentCheckIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" 使い方はこちら（開発中）"),
                _createVNode(_component_ClipboardDocumentCheckIcon, { class: "mb-1 inline h-6 w-6" })
            ])
        ])
    ]));
}
